import React from "react"
import ArticleListBlock from "../../blocks/articlesListBlock/ArticlesListBlock"
import Section from "../../../../core/layout/main/section/Section"

function ArticlesByTagSection({ articles, title, pageCount }) {
  return (
    <Section container>
      <ArticleListBlock
        articles={articles}
        bigTitle={title}
        showPageCount={pageCount}
      />
    </Section>
  )
}
export const name = "ArticlesByTagSection"

export const init = (componentData, pageContext) => {

  const currentTag = componentData.tag?.data?.attributes.label
  const articlesByTag = [] //pageContext.articlesByTags[currentTag].articles

  return (
    <ArticlesByTagSection
      key={componentData.id}
      articles={articlesByTag}
      title={componentData.label}
      pageCount={componentData.nombrePage}
    />
  )
}

export default ArticlesByTagSection
